module.exports = __webpack_public_path__ + "assets/img/img_three.11671994.png";